import React, { useEffect, useState, useContext } from 'react';
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import './ChatbotComp.scss';
import { useMutation } from 'react-query';
import { sendInfoChat } from '../api/chatbotAPI';
import ChatComponentWrapper from '../components/supportDashboard/ChatComponentWrapper';
import CustomHeader from '../components/chatDashboard/HeaderComponent';
import { useLocation } from 'react-router-dom'

const Chatbot = () => {
  const handleSendMessage = (message) => {
    setMessages(prevMessages => [...prevMessages, message]);
  };

  const newChatId = localStorage.getItem('chat_Id')
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [messages, setMessages] = useState([]);

  const [options, setOptions] = useState([]);

  const mutation = useMutation({
    mutationFn: ({ options, newChatId }) => sendInfoChat(options, newChatId),
    onSuccess: () => {
      console.log('Completado');
    },
    onError: (error) => {
      console.log('Error', error.message);
    },
  });

  useEffect(() => {
    console.log('Options updated:', options);
  }, [options]);

  const handleCall = async ({ options, values }) => {
    if (values.includes('contact-support')) {
      
      if (!values || values.length === 0) {
        console.error('No valid options to send, aborting');
        return;
      }
  
      try {
        const payload = { options: values, newChatId };
        console.log('Payload being sent:', payload);
  
        await mutation.mutateAsync(payload);
        console.log('Options sent successfully');
      } catch (error) {
        console.error('Error sending options:', error.message);
      }
    }
    if (Array.isArray(values) && values.length > 0) {
      setOptions(values);
      console.log('Options set:', values);
    } else {
      console.error('No valid values:', values);
    }
  };

  const toggleChat = () => {
    setIsChatOpen(prev => !prev);
  };

  const steps = [
    {
      id: '1',
      message: 'Hi! How can I help you today? Please choose a category:',
      trigger: '2',
    },
    {
      id: '2',
      options: [
        { value: 'general-information', label: 'General Information', trigger: 'gi-options' },
        { value: 'study-management', label: 'Study Management ', trigger: 'sm-options' },
        { value: 'system-features-and-usage', label: 'System Features and Usage', trigger: 'sf-options' },
        { value: 'contact-support', label: 'Chat With An Agent', trigger: 'contact-agent-chat' },
      ],
    },
    {
      id: 'contact-agent-chat',
      component: <ChatComponentWrapper/>,
      end: true,
    },

    {
      id: 'gi-options',
      message: 'You choose General Information. What do you need help with?',
      trigger: 'gi-choices',
    },
    {
      id: 'gi-choices',
      options: [
        { value: 'coverage analysis', label: 'What is a Coverage  Analysis?', trigger: 'coverage analysis' },
        { value: 'amendment', label: 'What is an amendment? ', trigger: 'amendment' },
        { value: 'billing grid', label: 'What is the billing grid?', trigger: 'billing grid' },
        { value: 'ginseng', label: 'What is Ginseng? ', trigger: 'ginseng' },
        { value: 'back', label: 'Back to menu', trigger: '2' },
      ],
    },
    {
      id: 'coverage analysis',
      message: `A Coverage Analysis is an examination of procedures detailed in a clinical study to determine which 
        services and procedures are eligible to be billed to Medicare. The process begins with a Qualifying Clinical 
        Trials (QCT) analysis, followed by an evaluation of the event schedule to create a billing grid.` ,
      trigger: 'gi-choices',
    },
    {
      id: 'amendment',
      message: `An amendment is a formal change or addition made to a research study after receiving regulatory approval.
       Changes can include modifications to the protocol, essential documents required by Ginseng, or other aspects of the study.`,
      trigger: 'gi-choices',
    },
    {
      id: 'billing grid',
      message: `A billing grid is a structured table used to organize and display billing information such as services provided,
        costs, and payment details. In Ginseng, it categorizes items with "S" (Sponsor-billed), "N" (Normal Care, billed to Medicare),
        or "NB" (Non-Billable). These labels can be customized to fit each institution's specific requirements.`,
      trigger: 'gi-choices',
    },
    {
      id: 'ginseng',
      message: `Ginseng is a software solution designed to automate the coverage analysis process, significantly reducing the 
        completion timeline. It streamlines the billing process for clinical trials, making it more efficient and effective.`,
      trigger: 'gi-choices',
    },


    {
      id: 'sm-options',
      message: 'You choose Study Management. What do you need help with?',
      trigger: 'sm-choices',
    },
    {
      id: 'sm-choices',
      options: [
        { value: 'documents-study', label: 'What documents are required to create a study in Ginseng?', trigger: 'documents-study' },
        { value: 'steps-study', label: 'What are the steps to create a study?', trigger: 'steps-study'},
        { value: 'time-to-completed', label: 'How long does it take to complete the process?', trigger: 'time-to-completed' },
        { value: 'documents-amendment', label: 'What documents are required to create an amendment? ', trigger: 'documents-amendment' },
        { value: 'steps-amendment', label: 'What are the steps to create an amendment? ', trigger: 'steps-amendment' },
        { value: 'amendment-without-creation-study', label: 'Can I create an amendment if I did not create the initial study in Ginseng?', trigger:'amendment-without-creation-study' },
        { value: 'back', label: 'Back to menu', trigger: '2' },
      ],
    },
    {
      id: 'documents-study',
      message: `The study protocol is the only mandatory document for creating a new study in Ginseng. Additional documents, such as the informed consent form or budget, can be
       uploaded if available. Although it is not mandatory, these documents will be stored and analyzed if provided.`,
      trigger: 'sm-choices',
    },
    {
      id: 'steps-study',
      message: `Steps to create a study: 
      a) Prepare and submit preliminary study data. 
      b) Upload study documents (only the protocol is mandatory).  
      c) Enter protocol details (such as the schedule of assessments, disease type, and objectives). 
      d) Approve the QCT. 
      e) Review, approve and download the billing grid. `,
      trigger: 'sm-choices',
    },
    {
      id: 'time-to-completed',
      message: `The initial billing grid is generated within minutes. The overall timeline depends on the user's promptness in reviewing and approving the grid.`,
      trigger: 'sm-choices',
    },
    {
      id: 'documents-amendment',
      message: `The study protocol is the only mandatory document needed to create an amendment in Ginseng. Other documents, such as the informed consent form or 
        budget, can be uploaded if available and will be analyzed if provided.`,
      trigger: 'sm-choices',
    },
    {
      id: 'steps-amendment',
      message: `Steps to create an amendment in Ginseng: 
      a) Review and edit preliminary study data provided by Ginseng. 
      b) Upload study documents (only the protocol is mandatory). 
      c) Enter protocol details (including the schedule of assessments, disease type, and objectives). 
      d) Approve the QCT. 
      e) Review, approve and download the billing grid `,
      trigger: 'sm-choices',
    },
    {
      id: 'amendment-without-creation-study',
      message: `Yes, you can. Once you click on “New Amendment,” you can create an amendment for a study that was not initially created in Ginseng.`,
      trigger: 'sm-choices',
    },
  
    {
      id: 'sf-options',
      message: 'You choose System Features and Usage.',
      trigger: 'sf-choices',
    },

    {
      id: 'sf-choices',
      options: [
        { value: 'search-study', label: 'Can I search for a specific study?', trigger: 'search-study' },
        { value: 'delete-study', label: 'Can I delete a study that I have already created?', trigger: 'delete-study' },
        { value: 'submitt-study', label: 'How can I submit a study with multiple cancer types?', trigger: 'submitt-study' },
        { value: 'study-created-correctly', label: 'How do I know if the study has been created correctly? ', trigger: 'study-created-correctly' },
        { value: 's-n-nb-meaning', label: 'What do “S,” “N,” and “NB” symbolize in a billing grid?', trigger: 's-n-nb-meaning' },
        { value: 'disagree-billing-grid', label: 'What if I disagree with some items in the initial billing grid?', trigger: 'disagree-billing-grid' },
        { value: 'back', label: 'Back to menu', trigger: '2' },
      ],
    },
    {
      id: 'search-study',
      message: `Yes, there is a search bar at the top of the dashboard where you can type the name of the study you are looking for.`,
      trigger: 'sf-choices',
    },
    {
      id: 'delete-study',
      message: `You can only delete studies you created if you have not yet submitted the protocol information for analysis.`,
      trigger: 'sf-choices',
    },
    {
      id: 'submitt-study',
      message: `When completing the protocol details, you can add another cancer type by selecting “+ New Row.”`,
      trigger: 'sf-choices',
    },
    {
      id: 'study-created-correctly',
      message: `Once the study is successfully created, it will display a “Submitted for Analysis” message. You will need to wait for the billing grid to be generated.`,
      trigger: 'sf-choices',
    },
    {
      id: 's-n-nb-meaning',
      message: `
       - “S” indicates the item is billed to the study's sponsor.   
       - “N” means the item is billed to Medicare or insurance.   
       - “NB” designates the item as non-billable.`,
      trigger: 'sf-choices',
    },
    {
      id: 'disagree-billing-grid',
      message: `If you disagree with an item in the initial billing grid, you can request a review. There is a “Comment” section in the last column where you can 
      explain your disagreement. At the bottom of the billing grid, click “Request Review” to send your request. Then, wait for the review process to be completed.`,
      trigger: 'sf-choices',
    },
  ];
    const theme = {
    background: '#f5f8fb',
    fontFamily: 'Arial, Helvetica, sans-serif',
    headerFontColor: '#272727',
    headerFontSize: '15px',
    botBubbleColor: '#5358a6',
    botFontColor: '#ffffff',
    userBubbleColor: '#eaeaea',
    userFontColor: '#272727',
  };
  const location = useLocation()
  if(location.pathname === '/' || location.pathname === '/login' || location.pathname.startsWith('/reset-password') || location.pathname === '/support-page') return null;
  return (
    <div className='chatbot-container'>
      {!isChatOpen && (
        <>
        <button onClick={toggleChat} className='icon-chatbot'>
          <img src='https://naur.ai/json/image_customer.png' alt='chatbot logo' className='support-icon'/>
        </button>
        <div className='greeting-container'>
          <p className='greegint-text'>We're Online! How can we help you today?</p>
        </div>
        </>
      )}
      {isChatOpen && (
        <div className='chat-header'>
            <ThemeProvider theme={theme}>
              <div className='chatbot-messages'>

              <ChatBot botAvatar={'https://naur.ai/json/image_customer.png'} headerComponent={<CustomHeader/>} steps={steps} 
              handleEnd={handleCall} />
              </div>
            <button className='close-button' onClick={toggleChat}>X</button>
            </ThemeProvider>
        </div>
      )}
    </div>
  );
};

export default Chatbot;
